export const ALL_ADMIN_USER_FETCH_START = "ALL_ADMIN_USER_FETCH_START"
export const ALL_ADMIN_USER_FETCH_SUCCESS = "ALL_ADMIN_USER_FETCH_SUCCESS"
export const ALL_ADMIN_USER_FETCH_FINISH = "ALL_ADMIN_USER_FETCH_FINISH"